import { useQuery } from "@tanstack/react-query";

import {
  FaxConfiguration,
  FaxConfigurationControllerApi,
} from "../../../services";
import { Identified } from "../../../types/sdk-types";
import {
  asPaginatedContent,
  getConfigObject,
  useBaseContent,
} from "../../../utils/utils";
/**
 *
 * @author Atish Bagate
 */
interface Props {
  xtenantId: string;
}

export function useGetFaxIntegration({
  xtenantId,
}: Props): useBaseContent<Identified<FaxConfiguration>> {
  return useQuery({
    queryKey: ["get-fax-integration-list"],
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new FaxConfigurationControllerApi(getConfigObject())
        .getConfigurations(xtenantId)
        .then((it) =>
          asPaginatedContent<Identified<FaxConfiguration>>(it?.data)
        ),
  });
}
